import {
    DashboardWidget,
    WidgetBody,
    WidgetDataPoint,
    WidgetFooter,
    WidgetHeader,
    WidgetSkeleton,
    WidgetType
} from "@flexinet/ui-components";
import {NavLink} from "react-router-dom";
import {Order} from "../../orders/types";

interface RecentOrdersWidgetProps {
    totalCount: number;
    latestOrder: Order | null;
    loading: boolean;
    customerId: string;
}

const formatDate = (dateStr?: string) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};

export const RecentOrdersWidget = ({totalCount, latestOrder, loading, customerId}: RecentOrdersWidgetProps) => {

    if (loading) {
        return <WidgetSkeleton/>;
    }

    const dataPoints: WidgetDataPoint[] = [
        {
            value: totalCount,
            label: latestOrder
                ? `Latest: ${formatDate(latestOrder.created)}`
                : 'No orders yet',
            color: totalCount > 0 ? 'violet' : 'gray',
        },
    ];

    const widget: WidgetType = {
        header: {
            title: 'Orders',
        },
        body: {
            dataPoints,
            metrics: [],
        },
        footer: {
            actionItems: [
                {
                    label: 'View All Orders',
                    component: {NavLink},
                    to: `/customers/${customerId}#tab=Orders`,
                    visible: true,
                },
            ],
        },
    };

    return (
        <DashboardWidget
            header={<WidgetHeader {...widget.header}/>}
            body={<WidgetBody {...widget.body}/>}
            footer={<WidgetFooter {...widget.footer}/>}
        />
    );
};
